import React, { Component } from "react";
import { TagCloud } from "react-tagcloud";

class WordCloudTemplate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: []
		};
	}

	componentDidMount() {
		let data = [];

		for (var key in this.props.data) {
			data.push({
				value: key,
				count: Math.log(this.props.data[key]) * 5
			});
		}

		this.setState(
			{
				data
			},
			() => console.log(this.state.data)
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.data !== this.props.data) {
			let data = [];

			for (var key in this.props.data) {
				data.push({
					value: key,
					count: Math.log(this.props.data[key]) * 5
				});
			}

			this.setState(
				{
					data
				},
				() => console.log(this.state.data)
			);
		}
	}

	render() {
		return (
			<div style={{ padding: "5% auto" }}>
				<TagCloud minSize={10} maxSize={45} tags={this.state.data} />
			</div>
		);
	}
}

export default WordCloudTemplate;



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/WordCloudTemplate.js